import { styled } from '@obvio/app'
import { Grid } from '@obvio/ui'

import type { AllowUndefinedForOptional } from '@obvio/utils'
import type { ReactElement } from 'react'

export type DisplayType = 'big' | 'small'

const DateCategoryWrap = styled(Grid)<{ $type?: DisplayType | undefined }>`
  align-items: center;
  color: #bdbbb8;
  display: ${(_, { $type }) => ($type === 'big' ? 'grid' : 'flex')};
`

const DateDivider = styled.span`
  margin: 0 0.2rem;
  font-weight: 300;
`

const DateNode = styled.span`
  text-align: end;
`

const Title = styled.span`
  text-align: start;
`

type DateCategoryProps = AllowUndefinedForOptional<{
  type?: DisplayType
  className?: string
  createdAt: string
  title: string
}>

export function BlogDateCategory({
  type,
  createdAt,
  title,
  className,
}: DateCategoryProps): ReactElement {
  const date = new Date(createdAt).toLocaleDateString('pl-PL')
  return (
    <DateCategoryWrap
      className={className}
      templateColumns="1fr auto 1fr"
      $type={type}
    >
      <DateNode>{date}</DateNode>
      <DateDivider> - </DateDivider>
      <Title>{title}</Title>
    </DateCategoryWrap>
  )
}
